import {Model} from '@vuex-orm/core'

export default class RoomtypesHasOperationmodesHasAirvolume extends Model {
  static entity = 'roomtypesHasOperationmodesHasAirvolumes'

  static fields() {
    return {
      id: this.number(null),
      operationmodes_id: this.attr(null),
      roomtypes_id: this.attr(null),

      label: this.string(null).nullable(),
      default: this.boolean(null),
      duration_airvolume: this.number(null),
      need_airvolume: this.number(null),
      window: this.number(null),
    }
  }
}
